/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Card, Carousel, Dropdown, Image, Tag } from "antd";
import {
  AmountIcon,
  DeleteIcon,
  PenIcon,
  PlusIcon,
  SearchIcon,
  StarFilledIcon,
} from "../../../../../atoms/CustomIcons";
import { MoreOutlined } from "@ant-design/icons";

export default function ProfileSidebar(props: any) {
  const { contacts } = props;
  const items = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/edit-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Edit details
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="delete-hover"
          icon={<DeleteIcon />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Delete
        </Button>
      ),
    },
  ];

  // const [contactDetails, setContactDetails] = useState({
  //   starred: false,
  //   signing: false,
  //   billing: false,
  // });
  return (
    <>
      <Card className="profileSidebar">
        <h4>Details</h4>
        <div className="sidebarInfo">
          <div
            className="infoWrapper"
            style={{
              width: "100%",
              alignItems: "center",
              justifyContent: "space-between",
              flexDirection: "row",
            }}
          >
            <h6 className="miniTitle" style={{ margin: 0 }}>
              Contract status
            </h6>
            <Tag className="accepted_tag">Contracted</Tag>
          </div>
        </div>

        <div className="contactCarousel">
          <div
            className="carouselHeading"
            style={{ fontSize: "16px", fontWeight: "700" }}
          >
            {" "}
            Contacts{" "}
          </div>

          <Carousel arrows infinite={false} dots={false}>
            {contacts?.map((x: any) => {
              return (
                <div className="carouselWrapper">
                  <div className="carouselTop">
                    <div className="leftCarousel">
                      <h5>{x.name}</h5>
                      <Tag
                        className={
                          x.title === "Senior Property Manager" ||
                          x.title === "Billing & Accounts Payable" ||
                          x.title === "Director of Land Development" ||
                          x.title === "Purchasing Coordinator"
                            ? "purple_tag"
                            : x.title === "Vendor Relations Coordinator" ||
                              x.title === "Project Manager"
                            ? "green_tag"
                            : x.title === "Property Manager"
                            ? "yellow_tag"
                            : "blue_tag"
                        }
                      >
                        {x.title}
                      </Tag>
                    </div>
                    <Dropdown
                      menu={{ items }}
                      trigger={["click"]}
                      placement="bottomRight"
                      className="actionButton"
                    >
                      <Button
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                        onKeyDown={(e) => e.stopPropagation()}
                        style={{
                          padding: "6px",
                        }}
                        className="only_icon btn-sm"
                        icon={<MoreOutlined />}
                      />
                    </Dropdown>
                  </div>
                  <div className="carouselContent">
                    <div className="contentWrapper">
                      <div className="leftWrapper">Phone:</div>
                      <div className="rightWrapper">{x.phone}</div>
                    </div>
                    <div className="contentWrapper">
                      <div className="leftWrapper">Email:</div>
                      <div className="rightWrapper">{x.email}</div>
                    </div>
                    <div className="contentWrapper">
                      <div className="leftWrapper">Roles:</div>
                      <div className="rightWrapper">
                        <div className="profileActionBtns">
                          <Button
                            type="text"
                            // onClick={() =>
                            //   setContactDetails((prev) => ({
                            //     ...prev,
                            //     starred: !prev.starred,
                            //   }))
                            // }
                            className={
                              x.is_starred ? "activeIcon" : "notActiveIcon"
                            }
                          >
                            <StarFilledIcon />
                          </Button>
                          <Button
                            type="text"
                            // onClick={() =>
                            //   setContactDetails((prev) => ({
                            //     ...prev,
                            //     signing: !prev.signing,
                            //   }))
                            // }
                            className={
                              x.is_signing ? "activeIcon" : "notActiveIcon"
                            }
                          >
                            <PenIcon />
                          </Button>
                          <Button
                            type="text"
                            // onClick={() =>
                            //   setContactDetails((prev) => ({
                            //     ...prev,
                            //     billing: !prev.billing,
                            //   }))
                            // }
                            className={
                              x.is_billing ? "activeIcon" : "notActiveIcon"
                            }
                          >
                            <AmountIcon />
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </Carousel>
        </div>
      </Card>

      <Card
        className="profileSidebar"
        onClick={() =>
          window.open(
            "https://www.figma.com/proto/tIRfYY9zJMm3JAkzuZz2Tn/LS--Branding---Marketing?page-id=2596%3A60353&node-id=2985-233871&p=f&viewport=3230%2C3079%2C0.31&t=BgbjHvEjnw9ohjvG-1&scaling=scale-down&content-scaling=fixed&starting-point-node-id=2985%3A233871",
            "_blank"
          )
        }
        style={{ marginTop: "8px", cursor: "pointer" }}
      >
        <div className="documentHeader">
          <h4>Documents</h4>

          <Button className="btn-sm" icon={<PlusIcon />} />
          <Button className="btn-sm" icon={<SearchIcon />} />
        </div>

        <div className="documentListWrapper">
          <Card className="documentList">
            <div className="documentItem">
              <Image
                src="/images/profile/icon-folder.svg"
                preview={false}
                width={16}
              />
              <span>Legal</span>
            </div>
            <div className="documentImage cs_tmp_image">
              <Image src="/images/dummy/client_doc_1.png" preview={false} />
            </div>
          </Card>
          <Card className="documentList">
            <div className="documentItem">
              <Image
                src="/images/profile/icon-folder.svg"
                preview={false}
                width={16}
              />
              <span>Proposals</span>
            </div>
            <div className="documentImage cs_tmp_image">
              <Image src="/images/dummy/client_doc_2.png" preview={false} />
            </div>
          </Card>
        </div>
      </Card>
    </>
  );
}
